import { render } from "./Fase7Page.vue?vue&type=template&id=60c44ffc&scoped=true"
const script = {}

import "./Fase7Page.vue?vue&type=style&index=0&id=60c44ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c44ffc"]])

export default __exports__